import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

import { UsuarioService } from './usuarios.service';
import { Usuario } from './../usuario/usuario';

declare var Materialize:any;

@Component({
  selector: 'app-cadastrar',
  templateUrl: './cadastrar.component.html',
  styleUrls: ['./usuarios.component.css'],
  providers:[UsuarioService]
})
export class CadastrarComponent implements OnInit, AfterViewChecked {
  titulo: string = "Criar meu cadastro";
  public usuario: Usuario;
  public busy: Promise<any>;

  constructor(private usuarioService: UsuarioService, private router: Router, private route: ActivatedRoute) {
    this.usuario = new Usuario();
  }

  carregarInformacoesParticipante(): void{
    this.usuario.tipo_documento = localStorage.getItem('tipo_documento');
    this.usuario.numero_documento = localStorage.getItem('numero_documento');
    this.usuario.nome = localStorage.getItem('nome');
  }

  salvar(): void{
    this.busy = this.usuarioService.saveUsuario(this.usuario)
          .then(() => this.goBack());
  }

  goBack(): void {
     this.router.navigate(['/aluno/login']);
  }

  ngOnInit() {
    this.carregarInformacoesParticipante();
  }

  ngAfterViewChecked() {
    Materialize.updateTextFields();
  }
}



// WEBPACK FOOTER //
// ./src/app/usuarios/cadastrar.component.ts